
const CancelButton = ({ isButton, onClose }) => {
    return (
        <button type="button" className={`${isButton ? "btn btn-theme btn-border" : "close-btn d-flex align-items-center"}`} onClick={onClose}>
            {isButton ?  'Cancel' : <i className="fa fa-times ms-2" aria-hidden="true"></i> }
        </button>
    );
};

export default CancelButton;